import InfoItem from "@/shared/presentation/components/info-item";
import { formatTextToCNPJ, formatTextToCPF } from "@/shared/utils/formatters";
import { Button } from "@reverb-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FlexLine } from "../company-owner/flex-line";
export var CompanyOwnerInformation = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var toggleModalInformationVisibility = _a.toggleModalInformationVisibility, client = _a.client;
    var t = useTranslation("my-account").t;
    var documentFormatted = client.document;
    if (client.document && client.documentType) {
        switch (client.documentType.description) {
            case "CPF":
                documentFormatted = formatTextToCPF(client.document);
                break;
            case "CNPJ":
                documentFormatted = formatTextToCNPJ(client.document);
                break;
            default:
                break;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FlexLine, null,
            React.createElement(InfoItem, { label: t("company-tab.company-name"), value: client.name }),
            React.createElement(InfoItem, { label: t("company-tab.trade-name"), value: (_b = client.tradeName) !== null && _b !== void 0 ? _b : "-" })),
        React.createElement(FlexLine, null,
            React.createElement(InfoItem, { label: t("company-tab.company-size"), value: (_d = (_c = client.employeeRange) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : "-" }),
            React.createElement(InfoItem, { label: t("company-tab.industry"), value: (_f = (_e = client.industry) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : "-" })),
        React.createElement(FlexLine, null,
            React.createElement(InfoItem, { label: t("company-tab.document-type"), value: (_h = (_g = client.documentType) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : "-" }),
            React.createElement(InfoItem, { label: t("company-tab.document-number"), value: documentFormatted !== null && documentFormatted !== void 0 ? documentFormatted : "-" })),
        React.createElement(FlexLine, null,
            React.createElement(InfoItem, { label: t("company-tab.website"), value: (_j = client.domain) !== null && _j !== void 0 ? _j : "-" })),
        React.createElement(FlexLine, { justifyContent: "flex-end" },
            React.createElement(Button, { variant: "outline", onClick: function () { return toggleModalInformationVisibility(); } }, t("company-tab.edit-company")))));
};
